import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-configurable-bundles-skeleton',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './configurable-bundles-skeleton.component.html',
  styleUrl: './configurable-bundles-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundlesSkeletonComponent {
}
